import moment from 'moment';
import {
    Datagrid, FunctionField, List, ShowButton, TextField} from 'react-admin';
import { useAppSelector } from '../../store/hooks';
import ResourceSelectDialogButton from '../Common/ResourceSelectDialogButton';


const VasList = () => {
    const isCustomSelectOpen = useAppSelector((state) => state.customSelect.value.open);
    return (
        <List>
            <Datagrid bulkActionButtons={false}>
                {/*Will be active if custom popup is open*/}
                {
                    isCustomSelectOpen &&
                    <ResourceSelectDialogButton />
                }
                <TextField source="id" sortable={false}/>
                <TextField source="name" sortable={false}/>
                <TextField source="description" sortable={false}/>
                <FunctionField label="Created At" sortable={false} render={(record: any) => record?.createdAt ? moment(record.createdAt).format('DD MMM YYYY') : '-'} />
                <FunctionField label="Updated At" sortable={false} render={(record: any) => record?.updatedAt ? moment(record.updatedAt).format('DD MMM YYYY') : '-'} />
                <ShowButton/>
            </Datagrid>
        </List>
    )
}

export default VasList;